import { useState } from "react";
import { useSubmitAssignmentMutation } from "../../../features/assignmentMark/assignmentMarkApi";

export default function Modal({
  open,
  control,
  assignment,
  user,
  assignmentSubmit,
}) {
  const { id: assignment_id, title, totalMark } = assignment[0];
  const { name: student_name, id: student_id } = user;
  const [repo_link, setRepo_Link] = useState();

  const [submitAssignment, { isLoading, isSuccess, isError }] =
    useSubmitAssignmentMutation();

  const handleSubmit = (e) => {
    e.preventDefault();
    const createdAt = new Date().toISOString();
    submitAssignment({
      student_id,
      student_name,
      assignment_id,
      title,
      createdAt,
      totalMark: Number(totalMark),
      mark: 0,
      repo_link,
      status: "pending",
    });
  };
  if (isSuccess) {
    assignmentSubmit();
    control();
  }
  return (
    open && (
      <>
        <section style={{ display: "flex" }}>
          <div
            style={{
              position: "fixed",
              justifyContent: "center",
              display: "flex",
              left: "0",
              width: "100%",
              top: "60%",
            }}
          >
            <form
              className="video-form"
              style={{
                background: "rgb(43 44 68)",
                padding: "20px",
                borderRadius: "20px",
                width: "40%",
              }}
              onSubmit={handleSubmit}
            >
              <div
                style={{
                  float: "right",
                  cursor: "pointer",
                }}
                onClick={control}
              >
                X
              </div>
              <div className="space-y-2">
                <label>Repository Link</label>
                <input
                  required
                  className="text-input"
                  type="text"
                  name="repo_link"
                  placeholder="Enter Repository Link"
                  onChange={(e) => setRepo_Link(e.target.value)}
                />
              </div>
              <button
                disabled={isLoading}
                type="submit"
                className="submit"
                id="lws-submit"
              >
                Submit Assignment
              </button>
              <div>
                {isLoading && <p className="text-center">Submiting ...</p>}
                {isError && <p className="text-center">Error Submit Data</p>}
                {isSuccess && (
                  <p className="text-center">Assignment Submit Succefully</p>
                )}
              </div>
            </form>
          </div>
        </section>
      </>
    )
  );
}
